import Vue from 'vue'
import Router from 'vue-router'

import ChangeEmail from '@/components/ChangeEmail.vue'
import ChangePassword from '../views/ChangePassword.vue'
import Cipeo from '../views/Cipeo.vue'
import Events from '../views/Events.vue'
import Extras from '../views/Extras.vue'
import Groups from '../views/Groups.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import RecoverUsername from '../views/RecoverUsername.vue'
import LoginRecovery from '../views/LoginRecovery.vue'
import MySchool from '../views/MySchool.vue'
import NonNormalizedAccounts from '../views/NonNormalizedAccounts.vue'
import RecoverPassword from '../views/RecoverPassword.vue'
import Perm from '../views/Permissions.vue'
import ResetPassword from '../views/ResetPassword.vue'
import Roles from '../views/Roles.vue'
import Services from '../views/Services.vue'
import Swagger from '../views/Swagger.vue'
import TempAccount from '../views/TempAccounts.vue'
import UserMassInsert from '../views/UserMassInsert.vue'
import Users from '../views/Users.vue'
import UsersMireo from '../views/UsersMireo.vue'

import store from '../store/index'
import Permissions from '@/models/constants/Permissions'
import Guests from '@/views/Guests.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      // Available when authenticated
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requirements: {
          loggedOut: true,
        },
        fallback: 'home',
      },
      // Login permission is checked only in the backend
    },
    {
      path: '/my-school',
      name: 'my-school',
      component: MySchool,
      // Login permission is checked only in the backend
    },
    {
      path: '/temporary-accounts',
      name: 'temporary-accounts',
      component: TempAccount,
      meta: {
        permissions: [Permissions.ListTempAccounts],
      },
    },
    {
      path: '/change-email',
      name: 'change-email',
      component: ChangeEmail,
      props: true,
      // ChangePassword permission is checked only in the backend
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
      props: true,
      // ChangePassword permission is checked only in the backend
    },
    {
      path: '/cipeo',
      name: 'cipeo',
      component: Cipeo,
      meta: {
        permissions: [Permissions.AccessCipeoView],
      },
      // ChangePassword permission is checked only in the backend
    },    {
      path: '/guests',
      name: 'guests',
      component: Guests,
      meta: {
        permissions: [Permissions.ManageGuestUsers],
      },
      // ChangePassword permission is checked only in the backend
    },
    {
      path: '/login-recovery',
      name: 'login-recovery',
      component: LoginRecovery,
      // LoginRecovery permission is checked only in the backend
    },
    {
      path: '/recover-username',
      name: 'recover-username',
      component: RecoverUsername,
      // RecoverUsername permission is checked only in the backend
    },
    {
      path: '/recover-password',
      name: 'recover-password',
      component: RecoverPassword,
      // RecoverPassword permission is checked only in the backend
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      // ResetPassword (own) permission is checked only in the backend
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: Perm,
      meta: {
        permissions: [Permissions.ManagePermissions],
      },
    },
    {
      path: '/roles',
      name: 'roles',
      component: Roles,
      meta: {
        permissions: [Permissions.ManageRoles, Permissions.ManageSchoolRoles],
      },
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      meta: {
        permissions: [Permissions.ManageServices],
      },
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      meta: {
        permissions: [
          Permissions.ListAllEvents,
          Permissions.ListSchoolsEvents,
          Permissions.ListUserEvents,
        ],
      },
    },
    {
      path: '/groups',
      name: 'groups',
      component: Groups,
      meta: {
        permissions: [
          Permissions.ManageAdGroups,
        ],
      },
    },
    {
      path: '/import-users-csv',
      name: 'import-users-csv',
      component: UserMassInsert,
      meta: {
        permissions: [Permissions.BulkImportTempAccounts],
      },
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        permissions: [
          Permissions.ListStudentAccounts,
          Permissions.ListSchoolStaffAccounts,
        ],
      },
    },
    {
      path: '/substitutes',
      name: 'substitutes',
      component: UsersMireo,
      meta: {
        permissions: [Permissions.ListMireoAccounts],
      },
    },
    {
      path: '/account-verification',
      name: 'account-verification',
      component: NonNormalizedAccounts,
      meta: {
        permissions: [
          Permissions.ListNonNormalizedAccounts,
          Permissions.ListWaitingForSyncAccounts,
        ],
      },
    },
    {
      path: '/openapi',
      name: 'openapi',
      component: Swagger,
      meta: {
        permissions: [Permissions.AccessOpenAPI],
      },
    },
    {
      path: '/extras',
      name: 'extras',
      component: Extras,
      meta: {
        permissions: [Permissions.ManageExtras],
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // Check if page requires permission
  if (to.meta!!.permissions) {
    // Check user logged in
    if (store.state.isLogged) {
      // If has permission
      if (
        (store.state.user!.permissions as []).some((permission) =>
          to.meta!.permissions.includes(permission),
        ) ||
        (to.meta!.permission === Permissions.ChangeOwnPassword &&
          store.state.user!.mustChangePassword)
      ) {
        next()
      } else {
        next({ name: 'home' })
      }
    } else {
      next({ name: 'home' })
    }
    // Login page should not be available when logged in
  } else if (
    to.meta!.requirements &&
    to.meta!.requirements.loggedOut &&
    store.state.isLogged
  ) {
    next({ name: to.meta!.fallback })
  } else {
    next()
  }
})

export default router
